import React from 'react';
import { useTabsContext } from 'src/ui/common/molecules/tabs/tabs.provider';
import { ITabContent } from 'src/ui/common/molecules/tabs/tabs.types';

export const TabContent = ({ children, tabId }: ITabContent) => {
    const { selectedTabId } = useTabsContext();

    if (selectedTabId !== tabId) {
        return null;
    }

    return <>{children}</>;
};
